import 'css-chunksrc/client/scenes/projectDetailsConfiguration/styles.scss';export default {
  "projectDetailsConfiguration": "_projectDetailsConfiguration_ytpan_1",
  "main": "_main_ytpan_8",
  "tabs": "_tabs_ytpan_14",
  "tab": "_tab_ytpan_14",
  "selectedTab": "_selectedTab_ytpan_34",
  "label": "_label_ytpan_41",
  "footer": "_footer_ytpan_48",
  "button": "_button_ytpan_63"
};